import React, { useState } from "react"
import styled from "styled-components"
import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"

import Lightbox from "./Lightbox"
import FormFuturaNewsletter from "./FormFuturaNewsletter"
import Snippet from "./Snippet"

import { media, mixins } from "../styles"

const FormWrapper = styled.div`
  background: ${({ theme }) => theme.white};
  padding: 0 10px 30px;

  @media ${media.md} {
    padding: 0 35px 60px;
  }

  h2 {
    ${mixins.title4}
  }
`

const Opener = styled.div`
  cursor: pointer;
`

const FuturaNewsletterLightbox = () => {
  const [showDialog, setShowDialog] = useState(false)

  const openLightbox = () => {
    setShowDialog(true)
  }
  const closeLightbox = () => setShowDialog(false)

  const data = useStaticQuery(graphql`
    query FuturaNewsletterLightboxQuery {
      teaser: file(relativePath: { eq: "content/teasers/futura-teaser.png" }) {
        childImageSharp {
          gatsbyImageData(width: 700, layout: CONSTRAINED)
        }
      }
    }
  `)

  return (
    <div>
      <Opener onClick={openLightbox}>
        <GatsbyImage
          alt="Subscribe to our Futura Newsletter - Shaping the future of fintech"
          image={data.teaser.childImageSharp.gatsbyImageData}
        />
      </Opener>
      <Lightbox
        ariaLabel={"Futura Newsletter"}
        close={closeLightbox}
        keepOpenOnOverlayClick={true}
        show={showDialog}
      >
        <FormWrapper>
          <h2>
            <Snippet id="futuraNewsletterLightboxHeader" field="header" />
          </h2>
          <FormFuturaNewsletter />
        </FormWrapper>
      </Lightbox>
    </div>
  )
}

export default FuturaNewsletterLightbox
